// src/services/shiftService.js
// Service for managing shift cash balances

import ApiService from './api'
import AppURLs from '../config/urls'

const ShiftService = {
  /**
   * Create a new shift cash balance (open shift)
   * @param {Object} data - The shift data
   * @param {string} data.openBalance - The opening balance amount
   * @param {string} data.branchId - The branch ID
   * @returns {Promise} API response
   */
  async openShift(data) {
    try {
      const response = await ApiService.post(AppURLs.SHIFTS.CREATE, data)
      console.log('✅ Shift opened successfully:', response)
      return response
    } catch (error) {
      console.error('❌ Error opening shift:', error)
      throw error
    }
  },

  /**
   * Close an existing shift cash balance
   * @param {string} shiftId - The shift balance ID
   * @param {Object} data - The close data
   * @param {string} data.closeBalance - The closing balance amount
   * @returns {Promise} API response
   */
  async closeShift(shiftId, data) {
    try {
      console.log('🔄 Closing shift:', { shiftId, data })
      const endpoint = ApiService.replaceUrlParams(AppURLs.SHIFTS.UPDATE, { id: shiftId })
      console.log('🌐 PATCH endpoint:', endpoint)
      
      const response = await ApiService.patch(endpoint, data)
      console.log('✅ Shift closed successfully:', response)
      return response
    } catch (error) {
      console.error('❌ Error closing shift:', error)
      console.error('❌ Error details:', {
        message: error.message,
        status: error.response?.status,
        statusText: error.response?.statusText,
        data: error.response?.data
      })
      throw error
    }
  },

  /**
   * Get current active shift for a user/branch
   * @param {string} branchId - The branch ID
   * @returns {Promise} API response
   */
  async getActiveShift(branchId) {
    try {
      const response = await ApiService.get(AppURLs.SHIFTS.GET_ALL, {
        branchId,
        status: 'active'
      })
      console.log('✅ Active shift fetched:', response)
      return response
    } catch (error) {
      console.error('❌ Error fetching active shift:', error)
      throw error
    }
  }
}

export default ShiftService
